module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box has-loading",
    class: 'box-' + _vm.tamanho
  }, [_c('app-content-loader', {
    attrs: {
      "is-loading": _vm.carregandoDados
    },
    on: {
      "update:isLoading": function($event) {
        _vm.carregandoDados = $event
      },
      "update:is-loading": function($event) {
        _vm.carregandoDados = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v("Notas e Frequências")]), _vm._v(" "), _c('div', {
    staticClass: "box-nav"
  }, [_c('div', {
    staticClass: "box-icon",
    attrs: {
      "title": "Recarregar Dados"
    },
    on: {
      "click": function($event) {
        return _vm.buscarMatriculasPeriodoAtivo()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-sync"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-content"
  }, [(_vm.listaContratosContagem === 0) ? _c('div', {
    staticClass: "box-content-vazio"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-content-full"
  }, [(_vm.listaContratosContagem > 1) ? _c('v-tabs', {
    attrs: {
      "slot": "extension",
      "fixed-tabs": "",
      "slider-color": "orange darken-3"
    },
    slot: "extension",
    model: {
      value: (_vm.contratoAtivo),
      callback: function($$v) {
        _vm.contratoAtivo = $$v
      },
      expression: "contratoAtivo"
    }
  }, _vm._l((_vm.contratos), function(contrato) {
    return _c('v-tab', {
      attrs: {
        "href": ("#tab-" + (contrato.id))
      }
    }, [_vm._v("\n                    " + _vm._s(contrato.descricao) + "\n                ")])
  }), 1) : _vm._e(), _vm._v(" "), (_vm.listaContratosContagem > 0) ? _c('v-tabs-items', {
    model: {
      value: (_vm.contratoAtivo),
      callback: function($$v) {
        _vm.contratoAtivo = $$v
      },
      expression: "contratoAtivo"
    }
  }, _vm._l((_vm.contratos), function(contrato) {
    return _c('v-tab-item', {
      attrs: {
        "id": ("tab-" + (contrato.id))
      }
    }, [_c('div', {
      staticClass: "notas-lista"
    }, [_c('div', {
      staticClass: "responsive-table"
    }, [(!contrato.competencias) ? _c('div', [_c('table', {
      staticClass: "dashboard-table"
    }, [_c('thead', [_c('tr', [_c('th', {
      attrs: {
        "width": _vm.posGraduacao ? '80%' : '40%'
      }
    }, [_vm._v("Disciplina")]), _vm._v(" "), _c('th', {
      attrs: {
        "width": "10%"
      }
    }, [_vm._v("Frequência")]), _vm._v(" "), (_vm.posGraduacao) ? _c('th', {
      attrs: {
        "width": "10%"
      }
    }, [_vm._v("Conceito")]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao) ? _c('th', {
      attrs: {
        "width": "10%"
      }
    }, [_vm._v("Nota 1")]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao) ? _c('th', {
      attrs: {
        "width": "10%"
      }
    }, [_vm._v("Nota 2")]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao) ? _c('th', {
      attrs: {
        "width": "10%"
      }
    }, [_vm._v("Nota 3")]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao && !_vm.todosPossuemMediaFinal) ? _c('th', {
      attrs: {
        "width": "10%"
      }
    }, [_vm._v("Média")]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao && _vm.possuiExame) ? _c('th', {
      attrs: {
        "width": "10%"
      }
    }, [_vm._v("Exame")]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao && _vm.possuiMediaFinal) ? _c('th', {
      attrs: {
        "width": "10%"
      }
    }, [_vm._v("Média Final")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((contrato.matriculas), function(item) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(item.disciplina))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.frequencias[0].frequencia) + "%")]), _vm._v(" "), (_vm.posGraduacao) ? _c('td', [_vm._v(_vm._s(item.conceito1 || '-'))]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao) ? _c('td', [_vm._v(_vm._s(item.nota1 || '-'))]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao) ? _c('td', [_vm._v(_vm._s(item.nota2 || '-'))]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao) ? _c('td', [_vm._v(_vm._s(item.nota3 || '-'))]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao && !_vm.todosPossuemMediaFinal) ? _c('td', [_vm._v(_vm._s(item.media || '-'))]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao && _vm.possuiExame) ? _c('td', [_vm._v(_vm._s(item.nota_exame || '-'))]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao && _vm.possuiMediaFinal) ? _c('td', [_vm._v(_vm._s(item.media_final || '-'))]) : _vm._e()])
    }), 0)])]) : _vm._e(), _vm._v(" "), (contrato.competencias) ? _c('div', [_c('h3', {
      staticClass: "title-tema"
    }, [_vm._v(_vm._s(contrato.competencias.desc_area_tematica))]), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('table', {
      staticClass: "dashboard-table modulo"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Disciplinas Módulo")]), _vm._v(" "), _c('th', [_vm._v("Frequência")])])]), _vm._v(" "), _c('tbody', _vm._l((contrato.competencias.disciplinas), function(disciplina) {
      return _c('tr', [(!disciplina.cpp) ? _c('td', [_vm._v(_vm._s(disciplina.desc_disciplina))]) : _vm._e(), _vm._v(" "), (!disciplina.cpp) ? _c('td', [_vm._v(_vm._s(disciplina.frequencias[0].frequencia) + "%")]) : _vm._e()])
    }), 0)])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm8": ""
      }
    }, [(contrato.competencias.avaliacoes.length > 0) ? _c('div', [_c('highcharts', {
      staticClass: "charts",
      attrs: {
        "options": _vm.chartOptions
      }
    })], 1) : _vm._e(), _vm._v(" "), (contrato.competencias.avaliacoes.length == 0) ? _c('div', [_c('v-container', {
      attrs: {
        "fluid": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "align-center": "",
        "justify-center": "",
        "row": "",
        "fill-height": "",
        "column": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('strong', [_vm._v("Nenhuma nota registrada")])])], 1)], 1)], 1) : _vm._e()])], 1), _vm._v(" "), _c('hr', {
      staticClass: "hr-notas-frequencias"
    }), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "my-2": ""
      }
    }, _vm._l((contrato.competencias.disciplinas), function(disciplina) {
      return _c('div', [_c('v-layout', {
        attrs: {
          "row": "",
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "sm4": ""
        }
      }, [(disciplina.cpp) ? _c('span', {
        staticClass: "text-disciplina"
      }, [_c('strong', [_vm._v("Disciplina CPP:")]), _vm._v(" " + _vm._s(disciplina.desc_disciplina))]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "sm2": ""
        }
      }, [(disciplina.cpp) ? _c('span', {
        staticClass: "text-disciplina"
      }, [_c('strong', [_vm._v("Frequência:")]), _vm._v(" " + _vm._s(disciplina.frequencias[0].frequencia) + "%")]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "sm6": ""
        }
      }, [_c('v-layout', {
        attrs: {
          "row": "",
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "sm4": ""
        }
      }, [(disciplina.cpp) ? _c('span', {
        staticClass: "text-disciplina"
      }, [_c('strong', [_vm._v("Nota 1:")]), _vm._v(" " + _vm._s(disciplina.nota1))]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "sm4": ""
        }
      }, [(disciplina.cpp) ? _c('span', {
        staticClass: "text-disciplina"
      }, [_c('strong', [_vm._v("Nota 2:")]), _vm._v(" " + _vm._s(disciplina.nota2))]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "sm4": ""
        }
      }, [(disciplina.cpp) ? _c('span', {
        staticClass: "text-disciplina"
      }, [_c('strong', [_vm._v("Média:")]), _vm._v(" " + _vm._s(disciplina.media))]) : _vm._e()])], 1)], 1)], 1)], 1)
    }), 0)], 1)], 1) : _vm._e()])])])
  }), 1) : _vm._e()], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "icon-vazio"
  }, [_c('i', {
    staticClass: "fas fa-graduation-cap"
  })]), _vm._v(" "), _c('h3', [_vm._v("Você não possui cursos ativos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e6740448!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/dashboard/NotasFrequencias.vue
// module id = 582
// module chunks = 2